import React from 'react';
import { Loading as OperationDiameterLoading } from 'operation-diameter';
import cx from 'classnames';
import styles from './Loading.module.scss';

const Loading = () => (
  <OperationDiameterLoading
    text="We'll just be a moment"
    additionalClassnames={cx(styles.loading, styles.loadingHeading)}
    data-testid='loading'
  />
);

export default Loading;
